import { Grid, useMediaQuery } from "@material-ui/core";
import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  DialogFormHLPure,
  DialogPrivacy,
  DialogSystemGLPure,
  GridSimpleReadHLPure,
  InputHLPure,
  Label,
  SimpleLoading,
} from "../../pures";
import { ArrowBtnMobile, LogoGovoLegal } from "../../../assets/logos/icons/index";
import govoLogo from './../../../assets/logos/logo_govo.legal.jpg'
import "./qr-signed-document.css";
import RenderMenu from "../../pures/adobePfdReader/PdfReader";
import { LogoColor } from "../../../assets/assets";

const QRSignedDocumentView = ({
  showLoadingRequesting,
  showCompletedRequesting,
  showErrorRequesting,
  toggleLoadingRequesting,
  toggleCompletedRequesting,
  toggleErrorRequesting,
  toggleWarningRequesting,
  showWarningRequesting,
  message,
  nameDocumentRequest,
  signType,
  hash,
  recordConservation,
  timeStamp,
  dataGrid,
  loading,
  proofOfLifeActive,
  documentGrid
}) => {
  const { t } = useTranslation();

  const [signerSelected, setSignerSelected] = useState({});
  const [documentSelected, setDocumentSelected] = useState({});
  const [nameComponentUser, setNameComponentUser] = useState("");
  const [modalTermsCond, setValidationForm] = useState(false);
  const [documentInfo, setDocumentInfo] = useState({})
  const [showDialog, setShowDialog] = useState(false)
  /** @type {[{url: string, name: string, generatedDate: string}, React.Dispatch<React.SetStateAction<{url: string, name: string, generatedDate: string}>]} */
  const [videoData, setVideoData] = useState({})
  const isMobile = useMediaQuery("(max-width:700px)")
  const [showType, setShowType] = useState("")
  const [openDocument, setOpenDocument] = useState(false)
  const is1000Width = useMediaQuery("(max-width:1000px)")

  const pdf = useMemo(
    () => (
      <RenderMenu
        className="pdfReader"
        url={documentInfo.url}
        awsURL
      />
    ),
    [documentInfo.url]
  );


  const handleClickImg = () => {
    window.open('https://govo.digital/', '_blank');
  }

  const handleClickGrid = (dataItem) => {
    if (dataItem.videoPath) {
      setVideoData({ url: dataItem.videoPath, name: dataItem.name, generatedDate: dataItem.date })
      setShowType("signer")
      if (window.innerWidth < 700) setShowDialog(true)
    }
  }

  const openModalTermsCond = (value) => {
    setValidationForm(value);
  };

  const showDocument = (dataItem) => {
    if (openDocument) {
      setOpenDocument(false)
      setDocumentInfo({})
      setShowType("")
      return
    }
    setOpenDocument(true)
    setShowType("document")
    setDocumentInfo(dataItem)
  }

  return (
    <div className="qrSignedDocument-container">
      {loading ? (
        <SimpleLoading />
      ) : (
        <>
          <div className="qrSignedDocument-container-header">
            <img
              src={govoLogo}
              alt="Logo de govo.legal"
              width='247' height='57'
            />
          </div>
          <div className="qrSignedDocument-elements-container">
            <Grid item lg={12} md={12} sm={12} es={12} xs={12}>
              <Label title={t("qrSignedDocument-label-document-signed")} />
            </Grid>
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              es={12}
              xs={12}
              className="qrSignedDocument-name-doc-container"
            >
              <InputHLPure
                labelInput={t("qrSignedDocument-label-document-name")}
                typeInput={"text"}
                disabled={true}
                tooltipShow={false}
                informationIcon={false}
                inputActive={true}
                valueInput={nameDocumentRequest}
              />
            </Grid>
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              es={12}
              xs={12}
              className="qrSignedDocument-typesigned-container"
            >
              <InputHLPure
                labelInput={t('qrSignedDocument.label.was.signed.with') + ' ' + signType}
                typeInput={"text"}
                disabled={true}
                tooltipShow={false}
                informationIcon={false}
                inputActive={false}
                readOnlyText={''}
              />
            </Grid>
            <Grid
              item
              className={proofOfLifeActive && "qrSignedDocument-grid"}
            >
              <div>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  xs={12}>
                  <GridSimpleReadHLPure
                    dataGrid={documentGrid}
                    skip={0}
                    take={5}
                    rowClick
                    onSelectedItem={setDocumentSelected}
                    titleRow1={"Archivo firmado"}
                    fieldRow1={"name"}
                    fieldSubtitle={"date"}
                    textSubtitle={"type"}
                    styleCol1={"qrSignedDocument-cellItemStyleCol1-document"}
                    handleIconArrow={proofOfLifeActive && showDocument}
                    columnFour={proofOfLifeActive}
                    columnFourCell={(props) =>
                      <td
                        className="qrSignedDocument-img-container-proofOfLife"
                        onClick={() => showDocument(props.dataItem)}
                      >
                        <img
                          className="qrSignedDocument-img-proofOfLife"
                          src={ArrowBtnMobile}
                        />
                      </td>
                    }
                  />
                </Grid>
                <GridSimpleReadHLPure
                  dataGrid={dataGrid}
                  skip={0}
                  take={5}
                  rowClick
                  titleRow1={t("qrSignedDocument-label-binnacle")}
                  fieldRow1={"name"}
                  fieldSubtitle={"date"}
                  textSubtitle={"type"}
                  styleCol1={"qrSignedDocument-cellItemStyleCol1"}
                  handleIconArrow={proofOfLifeActive && handleClickGrid}
                  onSelectedItem={setSignerSelected}
                  filter={false}
                  column2Status={false}
                  columnThree={proofOfLifeActive && !is1000Width}
                  styleCol3={"qrSignedDocument-cellItemStyleCol3"}
                  fieldRow3={"recognition"}
                  titleRow3={"Reconocimiento facial"}
                  columnFour={proofOfLifeActive}
                  columnFourTitle={"Acciones"}
                  columnFourCell={(props) => props.dataItem.videoPath &&
                    <td
                      className="qrSignedDocument-img-container-proofOfLife"
                      onClick={() => handleClickGrid(props.dataItem)}
                    >
                      <img
                        className="qrSignedDocument-img-proofOfLife"
                        src={`${process.env.REACT_APP_AWS_S3_BUCKET_URL}microservices/MiFirma/assets/inbox/icono_prueba_de_vida.svg`}
                      />
                    </td>
                  }
                />
                {!isMobile &&
                  <>
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      es={12}
                      xs={12}
                      className="qrSignedDocument-hash-container"
                    >
                      <InputHLPure
                        labelInput={t("qrSignedDocument-label-hash")}
                        typeInput={"text"}
                        disabled={true}
                        tooltipShow
                        informationIcon={true}
                        positionTooltip={"right"}
                        titleTooltip={"Hash"}
                        descriptionTooltip={t('qrSignedDocument.hash.tooltip.description')}
                        inputActive={true}
                        valueInput={hash}
                      />
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      es={12}
                      xs={12}
                      className="qrSignedDocument-conservation-container"
                    >
                      <InputHLPure
                        labelInput={t("qrSignedDocument-record-conservation")}
                        typeInput={"text"}
                        disabled={true}
                        tooltipShow
                        informationIcon={true}
                        positionTooltip={"right"}
                        titleTooltip={t("qrSignedDocument-record-conservation")}
                        descriptionTooltip={t('qrSignedDocument.record.conservation.tooltip.description')}
                        inputActive={true}
                        valueInput={recordConservation}
                        specialCase={recordConservation === 'No aplica' ? true : false}
                      />
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      es={12}
                      xs={12}
                      className="qrSignedDocument-timestamp-container"
                    >
                      <InputHLPure
                        labelInput={t("qrSignedDocument-timestamp")}
                        typeInput={"text"}
                        disabled={true}
                        tooltipShow
                        informationIcon={true}
                        positionTooltip={"right"}
                        titleTooltip={t("qrSignedDocument-timestamp")}
                        descriptionTooltip={t('qrSignedDocument.timestamp.tooltip.description')}
                        inputActive={true}
                        valueInput={timeStamp}
                        specialCase={timeStamp === 'No aplica' ? true : false}
                      />
                    </Grid>
                  </>
                }
                {documentInfo && documentInfo.url && showType === "document" && openDocument && isMobile && pdf}
              </div>
              {documentInfo && documentInfo.url && showType === "document" && openDocument && !isMobile && pdf}
              {(showDialog && proofOfLifeActive) &&
                <DialogFormHLPure
                  cancel={() => setShowDialog(false)}
                  titleDialog={`Video de ${videoData.name}`}
                >
                  {videoData && videoData.generatedDate && <span>{`Video grabado durante la firma del documento el ${videoData.generatedDate}`}</span>}
                  <video
                    className="qrSignedDocument-video-proofOfLife-dialog"
                    controls
                    disablePictureInPicture
                    disableRemotePlayback
                    src={videoData.url}
                  />
                </DialogFormHLPure>
              }
              {proofOfLifeActive && (!showType || showType === "signer") &&
                <div className="qrSignedDocument-container-video-proofOfLife">
                  {videoData && videoData.generatedDate && !isMobile && <span>{`Video grabado durante la firma del documento el ${videoData.generatedDate}`}</span>}
                  <video
                    controls
                    disablePictureInPicture
                    disableRemotePlayback
                    className="qrSignedDocument-video-proofOfLife"
                    src={videoData.url}
                  />
                </div>
              }
            </Grid>
            {isMobile &&
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                es={12}
                xs={12}
                className="qrSignedDocument-input-container"
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  xs={12}
                  className="qrSignedDocument-hash-container"
                >
                  <InputHLPure
                    labelInput={t("qrSignedDocument-label-hash")}
                    typeInput={"text"}
                    disabled={true}
                    tooltipShow
                    informationIcon={true}
                    positionTooltip={"right"}
                    titleTooltip={"Hash"}
                    descriptionTooltip={t('qrSignedDocument.hash.tooltip.description')}
                    inputActive={true}
                    valueInput={hash}
                  />
                </Grid>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  xs={12}
                  className="qrSignedDocument-conservation-container"
                >
                  <InputHLPure
                    labelInput={t("qrSignedDocument-record-conservation")}
                    typeInput={"text"}
                    disabled={true}
                    tooltipShow
                    informationIcon={true}
                    positionTooltip={"right"}
                    titleTooltip={t("qrSignedDocument-record-conservation")}
                    descriptionTooltip={t('qrSignedDocument.record.conservation.tooltip.description')}
                    inputActive={true}
                    valueInput={recordConservation}
                    specialCase={recordConservation === 'No aplica' ? true : false}
                  />
                </Grid>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  xs={12}
                  className="qrSignedDocument-timestamp-container"
                >
                  <InputHLPure
                    labelInput={t("qrSignedDocument-timestamp")}
                    typeInput={"text"}
                    disabled={true}
                    tooltipShow
                    informationIcon={true}
                    positionTooltip={"right"}
                    titleTooltip={t("qrSignedDocument-timestamp")}
                    descriptionTooltip={t('qrSignedDocument.timestamp.tooltip.description')}
                    inputActive={true}
                    valueInput={timeStamp}
                    specialCase={timeStamp === 'No aplica' ? true : false}
                  />
                </Grid>
              </Grid>
            }
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              es={12}
              xs={12}
              className="qrSignedDocument-conservation-container"
            >
              <a style={{ font: "normal normal 600 14px Quicksand", color: "#427FBA" }}
                href="https://govo.legal"
                target="_blank">
                {t("qrSignedDocument-label-use-govo")}
              </a>
            </Grid>
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              es={12}
              xs={12}
              className="qrSignedDocument-footer-img-container"
            >
              <button
                onClick={handleClickImg}
                className='qrSignedDocument-btn-img'
              >
                <img
                  alt="Logo de govo.legal footer"
                  src={LogoColor}
                  style={{ height: "58px" }}
                />
              </button>
            </Grid>
          </div>
          <Grid container justify="center" alignItems="center">
            <div className="footer-register-person" item>
              <div className="footer-elements">
                <div className="footer-textR-person">
                  <h2>Powered by A3 Cloud Microservices, S.A.P.I. de C.V.</h2>
                </div>
                <div className="footer-textL-person">
                  <h2
                    onClick={() => {
                      openModalTermsCond(true);
                    }}
                  >
                    Aviso de Privacidad
                  </h2>
                </div>
              </div>
            </div>
          </Grid>
          <DialogPrivacy
            openModalTermsCond={openModalTermsCond}
            modalTermsCond={modalTermsCond}
          />
          <DialogSystemGLPure
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            toggleWarningRequesting={toggleWarningRequesting}
            showWarningRequesting={showWarningRequesting}
            message={message}
          />
        </>
      )}
    </div>
  );
};

export { QRSignedDocumentView as default };
